<template>
    <div class="apply-page-container" ref="applyRoot">
        <ApplyHeader :leftButtonHandler="leftButtonHandler" pageName="form" />
        <div class="apply-page inner">
            <!-- <component
                :is="componentByApplySteps"
                v-bind="[currentProps, editProps, stageProps]"
                ref="component"
                @photo="receivePhoto"
                @disabled="updateDisabled"
                @jobCategory="getJobCategory"
                @onChangeDeletePhotoIds="onChangeDeletePhotoIds"
                @close="trigger"
            /> -->
            <component
                :is="componentByApplySteps"
                v-bind="[currentProps, editProps, stageProps]"
                ref="component"
                @photo="receivePhoto"
                @disabled="updateDisabled"
                @jobCategory="getJobCategory"
                @onChangeDeletePhotoIds="onChangeDeletePhotoIds"
                @close="onChildClose"
            />
            <ApplyBottomButton v-show="ctaActive" @click="trigger" v-bind="bottomButtonProps" :disabled="disabled" />
        </div>
    </div>
</template>

<script>
import profileService from '@/services/profile'
import ApplyHeader from './ApplyHeader.vue'
import { sendMetaTransition } from '@/services/meta-event'

export default {
    name: 'ApplyFormPage',
    components: {
        ApplyHeader,
        EditPhotos: () => import('@/routes/my-page/components/EditPhotos'),
        School: () => import('@/components/profile/School'),
        ItemSelector: () => import('@/components/profile/ItemSelector'),
        ItemSteps: () => import('@/components/profile/ItemSteps'),
        Health: () => import('@/components/profile/Health'),
        JobTypeA: () => import('@/components/profile/JobTypeA'),
        JobTypeB: () => import('@/components/profile/JobTypeB'),
        Finance: () => import('@/components/profile/Finance'),
        SiblingRelation: () => import('@/components/profile/SiblingRelation'),
        ParentRelation: () => import('@/components/profile/ParentRelation'),
        Family: () => import('@/components/profile/Family'),
        Intro: () => import('@/components/profile/Intro'),
        EmploymentType: () => import('@/components/profile/EmploymentType'),
        House: () => import('@/components/profile/House'),
        Sibling: () => import('@/components/profile/Sibling'),
        PersonalStory: () => import('@/components/profile/PersonalStory'),
    },
    data: () => ({
        disabled: true,
        job_category: null,
        deletePhotoIds: [],
        editProps: {},
        // jobType: 'A',
        jobType: null,
        lastStage: 0,
        profileFetched: false,
        _calledCheckJobCategory: false,
    }),
    mounted() {
        this.init()

        // 안드로이드 크롬에서 cta 가려짐 이슈 때문에 추가됨 2025.08.27
        // 안드로이드 크롬만 타겟
        const isAndroidChrome = (() => {
            const ua = navigator.userAgent || ''
            return /Android/i.test(ua) && /Chrome\/\d+/i.test(ua) && !/Edg|OPR|SamsungBrowser/i.test(ua)
        })()

        const setViewportInsets = () => {
            const rootEl = this.$refs.applyRoot
            if (!rootEl) return

            if (!isAndroidChrome || !window.visualViewport) {
                // 이 화면에만 0으로 명시 (다른 화면엔 아예 변수 자체가 없음)
                rootEl.style.setProperty('--android-bottom-ui', '0px')
                rootEl.style.setProperty('--android-top-ui', '0px')
                return
            }
            const vv = window.visualViewport
            // 상단 주소창/시스템 UI가 차지하는 높이
            const topUi = vv.offsetTop || 0
            // 하단(주소/툴바, 키보드 등)이 차지하는 높이
            const bottomUi = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop))
            // 미세 떨림 제거(임계값은 필요 시 조정)
            rootEl.style.setProperty('--android-top-ui', topUi >= 8 ? `${topUi}px` : '0px')
            rootEl.style.setProperty('--android-bottom-ui', bottomUi >= 8 ? `${bottomUi}px` : '0px')
        }

        // 보관해서 해제 용이하게
        this.__applySetViewportInsets = setViewportInsets

        setViewportInsets()
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', setViewportInsets)
        }
        window.addEventListener('resize', setViewportInsets)
        window.addEventListener('scroll', setViewportInsets, { passive: true })
    },
    created() {
        this.$registerBackHandler(this.leftButtonHandler)
    },
    beforeDestroy() {
        this.$unregisterBackHandler()

        // 안드로이드 크롬에서 cta 가려짐 이슈 때문에 추가됨 2025.08.27
        const fn = this.__applySetViewportInsets
        if (fn) {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', fn)
            }
            window.removeEventListener('resize', fn)
            window.removeEventListener('scroll', fn)
        }
    },
    computed: {
        stageProps() {
            return { stage: this.stage }
        },
        ctaActive() {
            const fieldWithCTA = [
                'height',
                'health_status',
                // 'bachelor',
                // 'master',
                // 'doctor',
                'jobDetail',
                'income',
                'asset',
                'brother_order',
                'family_asset',
                'father',
                'mother',
                'photo_upload',
                'intro',
                'only_to_manager',
                'car_model',
                'sibling',
                'companyNameModified',
                // 'look_score_self',
            ]

            return fieldWithCTA.indexOf(this.currentField.title) > -1 ? true : false
        },
        me() {
            return this.$store.getters.me
        },
        profile() {
            return this.$store.getters.profile
        },
        items() {
            return this.$store.getters.items
        },
        schoolId() {
            // return this.$store.getters.profile.school_id || 0
            return (this.$store.getters.profile.school || {}).id || this.$store.getters.profile.school_id || 0
        },
        noCar() {
            return this.$store.getters.profile.profile_options.some(o => Number(o.profile_option_id) === 205)
        },
        photo: {
            get() {
                return this.$store.getters.me.photos || ''
            },
            set(photo) {
                this.$set(this.me, 'photos', photo)
            },
        },
        stage: {
            get() {
                return this.$store.getters.applyStep
            },
            set(step) {
                const dom = document.querySelector('.apply-page-container')
                dom.scrollTo(0, 0)
                window.localStorage.setItem('applyStep', Number(step))

                this.$store.commit('setApplyStep', step)
            },
        },

        doubleBtnsInfo() {
            const next = {
                style: {
                    backgroundColor: 'none',
                    color: '#111111',
                    border: 'solid 1px #B9BDC1',
                },
                title: '나중에 하기',
                click: this.pass,
            }
            const disabled = {
                style: {
                    backgroundColor: '#F7F8F9',
                    color: '#B9BDC1',
                    border: 'none',
                },
                title: '다음',
                click: this.trigger,
            }
            const save = {
                style: {
                    backgroundColor: '#070A0E',
                    color: '#FFFFFF',
                    border: 'none',
                },
                title: '다음',
                click: this.trigger,
            }

            if (this.disabled) {
                return [next, disabled]
            }
            return [next, save]
        },
        bottomButtonProps() {
            // if (['master', 'doctor', 'intro'].indexOf(this.currentField.title) > -1) {
            // if (['intro'].indexOf(this.currentField.title) > -1) {
            //     return { doubleBtn: true, doubleBtnsInfo: this.doubleBtnsInfo }
            // } else {
            console.log('stage', this.stage)
            if (this.stage === this.lastStage) {
                return { label: '심사 요청하기', doubleBtn: false, blackBtn: true }
            }
            return { label: '다음', doubleBtn: false, blackBtn: true }
            // }
        },
        componentByApplySteps() {
            // 키
            if (this.currentField.title === 'height') return 'ItemSelector'
            // 지역
            if (this.currentField.title === 'state') return 'ItemSteps'
            if (this.currentField.title === 'mbti') return 'ItemSelector'
            // 흡연
            if (this.currentField.title === 'smoking') return 'ItemSelector'
            if (this.currentField.title === 'religion') return 'ItemSelector'
            if (this.currentField.title === 'schools') return 'ItemSelector'
            if (this.currentField.title === 'bachelor') return 'ItemSelector'
            if (this.currentField.title === 'bachelor_college') return 'ItemSelector'
            if (this.currentField.title === 'bachelor_major') return 'ItemSelector'
            // 석/박사 추가
            if (this.currentField.title === 'master') return 'ItemSelector'
            if (this.currentField.title === 'master_college') return 'ItemSelector'
            if (this.currentField.title === 'master_major') return 'ItemSelector'
            if (this.currentField.title === 'doctor') return 'ItemSelector'
            if (this.currentField.title === 'doctor_college') return 'ItemSelector'
            if (this.currentField.title === 'doctor_major') return 'ItemSelector'
            // 직장 직업 분류
            if (this.currentField.title === 'job_category') return 'ItemSelector'
            // 회사명
            if (this.currentField.title === 'company') return 'ItemSelector'
            if (this.currentField.title === 'companyNameModified') return 'Intro'
            if (this.currentField.title === 'jobDetail') return 'Intro'
            if (this.currentField.title === 'employment_type') return 'EmploymentType'
            if (this.currentField.title === 'company_state') return 'ItemSteps'

            if (this.currentField.title === 'income') return 'Finance'
            if (this.currentField.title === 'asset') return 'Finance'
            // 하우스
            // if (this.currentField.title === 'house_style') return 'House'
            // if (this.currentField.title === 'house_payment') return 'House'
            if (this.currentField.title === 'car') return 'ItemSteps'
            if (this.currentField.title === 'car_model') return 'Intro'

            // if (this.currentField.title === 'brother_order') return 'SiblingRelation'
            // if (this.currentField.title === 'parent_status') return 'ParentRelation'
            // if (this.currentField.title === 'family_asset') return 'Finance'
            // if (this.currentField.title === 'father') return 'Family'
            // if (this.currentField.title === 'mother') return 'Family'
            // if (this.currentField.title === 'sibling') return 'Sibling'
            if (this.currentField.title === 'marry_plan') return 'ItemSelector'
            if (this.currentField.title === 'marry') return 'ItemSelector'
            // if (this.currentField.title === 'child_plan') return 'ItemSelector'
            // if (this.currentField.title === 'career_plan') return 'ItemSelector'
            if (this.currentField.title === 'photo_upload') return 'EditPhotos'
            // if (this.currentField.title === 'intro') return 'Intro'
            // if (this.currentField.title === 'only_to_manager') return 'Intro'
            // 퍼스널 스토리
            if (this.currentField.title === 'personal_story') return 'PersonalStory'

            if (this.currentField.title === 'look_score_self') return 'ItemSelector'

            return ''
        },
        currentProps() {
            if (this.currentField.title === 'height') return { options: { model: 'height' } }
            if (this.currentField.title === 'state') return { options: { model: 'state', title: 'state' } }
            if (this.currentField.title === 'mbti') return { options: { model: 'mbti', title: 'mbti' } }
            if (this.currentField.title === 'smoking') return { options: { model: 'smoking' } }
            if (this.currentField.title === 'religion') return { options: { model: 'religion' } }
            if (this.currentField.title === 'health_status') return { type: 'health_status' }
            if (this.currentField.title === 'schools') return { options: { model: 'schools', title: 'edu_background' } }
            if (this.currentField.title === 'bachelor')
                return { options: { model: 'university', title: 'bachelor_university' } }
            if (this.currentField.title === 'bachelor_college')
                return { options: { model: 'college', title: 'bachelor_college' } }
            if (this.currentField.title === 'bachelor_major')
                return { options: { model: 'major', title: 'bachelor_major' } }
            if (this.currentField.title === 'master')
                return { options: { model: 'university', title: 'master_university' } }
            if (this.currentField.title === 'master_college')
                return { options: { model: 'college', title: 'master_college' } }
            if (this.currentField.title === 'master_major')
                return { options: { model: 'major', title: 'master_major' } }
            if (this.currentField.title === 'doctor')
                return { options: { model: 'university', title: 'doctor_university' } }
            if (this.currentField.title === 'doctor_college')
                return { options: { model: 'college', title: 'doctor_college' } }
            if (this.currentField.title === 'doctor_major')
                return { options: { model: 'major', title: 'doctor_major' } }
            // 직장직업 분류
            if (this.currentField.title === 'job_category') return { options: { model: 'jobCategory' } }
            if (this.currentField.title === 'company') return { options: { model: 'company' } }
            if (this.currentField.title === 'companyNameModified')
                return {
                    type: 'companyNameModified',
                    section: 'Personal',
                    inputMode: true,
                }
            if (this.currentField.title === 'jobDetail') {
                if (this.jobType === 'A') {
                    return {
                        type: 'job',
                        section: 'Personal',
                        inputMode: true,
                        job_category: this.job_category,
                        jobType: this.jobType,
                    }
                } else if (this.jobType === 'C') {
                    return {
                        type: 'job',
                        section: 'Personal',
                        inputMode: false,
                        job_category: this.job_category,
                        jobType: this.jobType,
                    }
                }
                // return {
                //     type: 'job',
                //     section: 'Personal',
                //     inputMode: false,
                //     job_category: this.job_category,
                //     jobType: this.jobType,
                // }
            }
            if (this.currentField.title === 'company_state')
                return { options: { model: 'state', title: 'company_state' } }
            if (this.currentField.title === 'income') return { type: 'income', section: 'Financial' }
            if (this.currentField.title === 'asset') return { type: 'asset', section: 'Financial' }

            if (this.currentField.title === 'house_style') return { type: 'house_style', section: 'House' }
            if (this.currentField.title === 'house_payment') return { type: 'house_payment', section: 'House' }
            if (this.currentField.title === 'car') return { options: { model: 'car', title: 'car' } }
            if (this.currentField.title === 'car_model')
                return { type: 'car_model', section: 'Financial', inputMode: true }

            if (this.currentField.title === 'brother_order') return { type: 'family_relations' }
            if (this.currentField.title === 'parent_status') return { type: 'parent_status' }
            if (this.currentField.title === 'family_asset') return { type: 'family_asset', section: 'Financial' }
            if (this.currentField.title === 'father') return { familyType: { id: 0, name: 'father' } }
            if (this.currentField.title === 'mother') return { familyType: { id: 1, name: 'mother' } }
            if (this.currentField.title === 'sibling') return { familyType: { id: 2, name: 'sibling' } }
            if (this.currentField.title === 'marry_plan') return { options: { model: 'marry_plan' } }
            if (this.currentField.title === 'marry') return { options: { model: 'marry' } }
            if (this.currentField.title === 'child_plan') return { options: { model: 'child_plan' } }
            if (this.currentField.title === 'career_plan') return { options: { model: 'career_plan' } }
            if (this.currentField.title === 'photo_upload') return { value: this.photo, showTitle: true }
            if (this.currentField.title === 'intro') return { type: 'intro', section: 'Personal' }
            if (this.currentField.title === 'only_to_manager') return { type: 'onlymanager', section: 'Personal' }

            if (this.currentField.title === 'personal_story')
                return { options: { model: 'personalStory', title: 'personal_story' } }

            if (this.currentField.title === 'look_score_self') return { options: { model: 'look_score_self' } }

            return ''
        },

        stages() {
            return [
                {
                    id: 1,
                    title: 'height',
                },
                {
                    id: 2,
                    title: 'state',
                },
                {
                    id: 3,
                    title: 'schools',
                },
                {
                    id: 4,
                    title: 'bachelor',
                },
                {
                    id: 5,
                    title: 'bachelor_major',
                },
                {
                    id: 6,
                    title: 'master',
                },
                {
                    id: 7,
                    title: 'master_major',
                },
                {
                    id: 8,
                    title: 'doctor',
                },
                {
                    id: 9,
                    title: 'doctor_major',
                },
                {
                    id: 10,
                    title: 'job_category',
                },
                {
                    id: 11,
                    title: 'company',
                },
                {
                    id: 12,
                    title: 'company_state',
                },
                {
                    id: 13,
                    title: 'jobDetail',
                },
                {
                    id: 14,
                    title: 'marry',
                },
                {
                    id: 15,
                    title: 'income',
                },
                {
                    id: 16,
                    title: 'asset',
                },
                {
                    id: 17,
                    title: 'look_score_self',
                },
                {
                    id: 18,
                    title: 'mbti',
                },
                {
                    id: 19,
                    title: 'smoking',
                },
                {
                    id: 20,
                    title: 'religion',
                },
                {
                    id: 21,
                    title: 'marry_plan',
                },
                {
                    id: 22,
                    title: 'photo_upload',
                },
                {
                    id: 23,
                    title: 'personal_story',
                },
            ]
        },
        currentField() {
            return this.stages.filter(s => s.id === this.stage)[0]
        },
    },
    watch: {
        stage() {
            this.firebaseEvent()
        },
        profile: {
            handler(newVal) {
                console.log('watch profile', this.profileFetched, newVal)
                if (newVal && newVal.company && newVal.company.length && !this._calledCheckJobCategory) {
                    this._calledCheckJobCategory = true
                    this.checkJobCategory()
                }
                if (!this.profileFetched) {
                    this.profileFetched = true
                    this.init_default_stage()
                }
            },
            deep: true,
            immediate: false,
        },
    },
    methods: {
        async onChildClose() {
            // ItemSteps의 selected 반영 타이밍 방어
            await this.$nextTick()
            return this.trigger()
        },
        firebaseEvent() {
            let eventName = ''
            // if (this.currentField.title === 'health_status') {
            //     eventName = 'health'
            // } else if (this.currentField.title === 'marry_plan') {
            //     eventName = 'marriage_plan'
            // } else if (this.currentField.title === 'child_plan') {
            //     eventName = 'children_plan'
            // } else if (this.currentField.title === 'career_plan') {
            //     eventName = 'career_plan'
            // } else if (this.currentField.title === 'only_to_manager') {
            //     eventName = 'to_manager'
            // } else {
            eventName = this.currentField.title
            // }
            this.$nativeBridge.postMessage({
                action: 'sendFirebaseEvent',
                value: {
                    category: `Enter_${this.$case.toPascal(eventName)}Page_After`,
                },
            })
        },
        async init() {
            if (!this.$store.getters.jobCategories) {
                this.$store.dispatch('loadConstants')
            }
            this.$store.dispatch('loadProfile')
            this.$nativeBridge.postMessage({
                action: 'setBackgroundColor',
                value: {
                    top: '#FAF0E1',
                    bottom: '#FFF9EF',
                },
            })

            this.lastStage = this.stages.length
            this.firebaseEvent()
            // try {
            //     this.checkJobCategory()
            //     const step = Number(window.localStorage.getItem('applyStep'))
            //     const targetStage = this.setInitialStage()
            //     console.log('targetStage', targetStage)
            //     if (targetStage === 8) {
            //         // company
            //         this.$store.commit('setApplyStep', 7)
            //         // this.$store.commit('setApplyStep', 16)
            //     // } else if (step) {
            //     //     this.$store.commit('setApplyStep', Number(step))
            //     } else {
            //         this.$store.commit('setApplyStep', this.setInitialStage())
            //     }
            // } catch (e) {
            //     console.log('error', e)
            //     // Promise 타입이면 toast 안 띄움
            //     if (e.data && typeof e.data.then !== 'function') {
            //         this.$toast.error(e.data)
            //     }
            // }
        },
        init_default_stage() {
            try {
                this.checkJobCategory()
                // const step = Number(window.localStorage.getItem('applyStep'))
                const targetStage = this.setInitialStage()
                console.log('targetStage', targetStage)
                if (targetStage === 8) {
                    // company
                    this.$store.commit('setApplyStep', 7)
                    // this.$store.commit('setApplyStep', 16)
                    // } else if (step) {
                    //     this.$store.commit('setApplyStep', Number(step))
                } else {
                    this.$store.commit('setApplyStep', targetStage)
                }
            } catch (e) {
                console.log('error', e)
                // Promise 타입이면 toast 안 띄움
                if (e.data && typeof e.data.then !== 'function') {
                    this.$toast.error(e.data)
                }
            }
        },
        pass() {
            console.log('pass', this.stage)
            this.stage++
        },
        async trigger() {
            console.log('trigger', this.currentField.title)
            if (this.currentField.title !== 'personal_story') {
                const child = this.$refs.component
                const res = await child.onSave(this.currentField.title)
                if (res) return
                await this.saveProfile()
            }
            if (this.stage === this.lastStage) {
                this.$fbPixel.track('AddPaymentInfo')
                sendMetaTransition('AddPaymentInfo')

                // this.$nativeBridge.postMessage({
                //     action: 'sendAirbridgeEvent',
                //     value: {
                //         category: `Complete_Profile_Story`,
                //     },
                // })
                this.$nativeBridge.postMessage({
                    action: 'sendFirebaseEvent',
                    value: {
                        category: `Complete_ProfileInput`,
                    },
                })
                setTimeout(async () => {
                    // this.$stackRouter.pop()
                    await this.$store.dispatch('loadMe')
                    // await this.$store.dispatch('loadProfile')
                    this.$router.push({ name: 'ApplyResultPage' })
                    // this.$router.push({ name: 'ApplyResultWithProductPage' })
                }, 500)
            } else {
                this.moveForward()
            }

            this.disabled = true
        },
        moveForward() {
            // console.log('moveForward', this.stage)
            let nextStage = this.stage + 1

            // this.stage++
            if ([6, 7, 8, 9].includes(nextStage)) {
                const schoolId = (this.profile.school || {}).id || this.profile.school_id
                if (nextStage === 6) {
                    // console.log('ddddddd', schoolId)
                    if (schoolId >= 5) {
                        nextStage = 10
                    } else if (this.profile.master_u_name) {
                        nextStage++
                    }
                }

                if (nextStage === 7 && this.profile.master_m_name) nextStage++
                if (nextStage === 8) {
                    if (schoolId >= 3) {
                        nextStage = 10
                    } else if (this.profile.doctor_u_name) {
                        nextStage++
                    }
                }

                if (nextStage === 9 && this.profile.doctor_m_name) nextStage++
            }
            if (this.currentField.title === 'job_category' && this.jobType === 'B') {
                // 'B' detail no필요
                // B는 대학생 같은 '직장구분'이 해당해서 세부 입력 없이 바로 넘김
                const stageToMove = this.stages.find(s => s.title === 'marry')
                nextStage = stageToMove.id
                // } else if (this.currentField.title === 'job_category' && this.jobType === 'C') {
                //     // 'C' detail필요
                //     const stageToMove = this.stages.find(s => s.title === 'jobDetail')
                //     this.stage = stageToMove.id
            }

            this.stage = nextStage

            // if (
            //     (this.currentField.title === 'schools' && this.schoolId === 9) ||
            //     (this.currentField.title === 'bachelor_major' && this.schoolId > 4 && this.schoolId < 9) ||
            //     (this.currentField.title === 'master_major' && this.schoolId > 2)
            // ) {
            //     const stageToMove = this.stages.find(s => s.title === 'job_category')
            //     this.stage = stageToMove.id
            // } else if (this.currentField.title === 'job_category' && this.jobType === 'B') {
            //     // 'B' detail no필요
            //     const stageToMove = this.stages.find(s => s.title === 'income')
            //     this.stage = stageToMove.id
            //     // } else if (this.currentField.title === 'job_category' && this.jobType === 'C') {
            //     //     // 'C' detail필요
            //     //     const stageToMove = this.stages.find(s => s.title === 'jobDetail')
            //     //     this.stage = stageToMove.id
            // } else if (this.currentField.title === 'car' && this.noCar) {
            //     this.stage = this.stage + 2
            // } else {
            //     this.stage++
            // }
        },
        moveBack() {
            // this.stage--
            // console.log('moveBack', this.currentField.title, this.schoolId)
            if (this.currentField.title === 'income') {
                if (this.jobType === 'B') {
                    const stageToMove = this.stages.find(s => s.title === 'job_category')
                    this.stage = stageToMove.id
                } else {
                    this.stage--
                }
            } else if (this.currentField.title === 'jobDetail') {
                const stageToMove = this.stages.find(s => s.title === 'job_category')
                if (this.jobType === 'C') {
                    this.stage = stageToMove.id
                } else {
                    this.stage--
                }
            } else if (this.currentField.title === 'job_category') {
                if (this.schoolId === 9) {
                    // 최종학력 고등인경우
                    const stageToMove = this.stages.find(s => s.title === 'schools')
                    this.stage = stageToMove.id
                } else if (this.schoolId > 4 && this.schoolId < 9) {
                    // 최종학력 학사
                    const stageToMove = this.stages.find(s => s.title === 'bachelor_major')
                    this.stage = stageToMove.id
                } else if (this.schoolId > 2) {
                    // 최종학력 석사
                    const stageToMove = this.stages.find(s => s.title === 'master_major')
                    this.stage = stageToMove.id
                } else {
                    // 최종학력 박사
                    this.stage--
                }
                // } else if (this.currentField.title === 'brother_order' && this.noCar) {
                //     this.stage = this.stage - 2
            } else {
                this.stage--
            }
        },
        async onClose() {
            const idx = await this.$modal.basic({
                title: '프로필 작성을 그만하시겠습니까?',
                body: '현재 작성한 부분까지 임시저장됩니다.',
                showCloseButton: false,
                buttons: [
                    {
                        label: '취소',
                        class: 'btn-default',
                    },
                    {
                        label: '확인',
                        class: 'btn-primary',
                    },
                ],
            })
            if (idx) {
                const child = this.$refs.component
                const res = await child.onSave(this.currentField.title)
                if (res) {
                    // console.log('입력하신 정보를 임시저장했습니다!')
                    this.$toast.success('입력하신 정보를 임시저장했습니다!')
                    this.$stackRouter.pop()
                    return
                }
                await this.saveProfile()
                this.$stackRouter.pop()
                // this.$stackRouter.push({ name: 'ChatsPage' })
            }
        },
        receivePhoto(photo) {
            this.photo = photo
        },
        leftButtonHandler() {
            if (this.stage === 1) {
                // this.$stackRouter.pop()
                this.$router.go(-1)
            } else {
                this.moveBack()
            }
        },
        updateDisabled(disabled) {
            this.disabled = disabled
        },
        checkJobCategory() {
            if (!(this.profile && this.profile.company) || !Array.isArray(this.profile.company)) return

            if (this.profile.company.length) {
                const profileItems = this.$store.getters.jobCategories
                if (profileItems) {
                    profileItems.forEach(item => {
                        if (item.id === this.profile.company[0].job_category_id) {
                            this.getJobCategory(item)
                        }
                    })
                }
            }
        },
        getJobCategory(jobCategory) {
            this.job_category = jobCategory
            // this.jobType = 'A'

            if (this.$profile.jobFreePage(jobCategory.id)) {
                const needDetail = [12, 13, 14]
                if (needDetail.indexOf(jobCategory.id) > -1) {
                    this.jobType = 'C'
                } else {
                    this.jobType = 'B'
                }
            } else {
                this.jobType = 'A'
            }
        },
        onChangeDeletePhotoIds(deletePhotoIds) {
            this.deletePhotoIds = deletePhotoIds
        },
        async saveProfile() {
            try {
                // throw new Error('Something went wrong');
                this.$loading(true)
                const { first_complete_profile: complete } = await profileService.update(this.preparedPayload())
                this.$loading(false)
                if (complete) {
                    // this.$store.dispatch('loadProfile')
                    this.$store.dispatch('loadMe')
                }
                console.log('입력하신 정보를 임시저장했습니다!')
                // this.$toast.success('입력하신 정보를 임시저장했습니다!')
            } catch (e) {
                console.log(e)
                this.$loading(false)
                const errorMessage = (e && e.data && (e.data.msg || e.data)) || '저장 중 오류가 발생했습니다.'
                this.$toast.error(errorMessage)
                const fullMsg = errorMessage + ' - ' + ((this.currentField || {}).title || '')
                console.log('fullMsg', fullMsg)
                await profileService.sendSlackMsg({ profile: this.profile, errMsg: fullMsg })
                throw e
            }
        },
        preparedPayload() {
            const keys = [
                'height',
                'state',
                'smoking',
                'religion',
                // 'health_status',
                'bachelor',
                'master',
                'doctor',
                'company',
                'income',
                'asset',
                // 'family_relations', // 형제관계
                // 'parent_status',
                // 'family_asset',
                // 'family',
                'marry_plan',
                'marry',
                // 'child_plan',
                // 'career_plan',
                // 'intro',
                // 'only_to_manager',
                'school_id',
                // 'house_style',
                // 'car_model',
                'look_score_self',
            ]
            const form = new FormData()
            form.append('id', this.profile.id)
            keys.forEach(key => {
                const snake = this.$case.toSnake(key)
                if (this.profile[snake] === null) return

                if (snake === 'smoking') {
                    form.append('smoking', this.profile.smoking ? '1' : '0')
                    return
                }

                if (this.$profile.needProfileOption(snake)) return

                // if (snake === 'car') {
                //     if (this.profile.car) {
                //         form.append('car_model', this.profile.car_model)
                //         return
                //     } else {
                //         form.append('car_model', '')
                //     }
                // }

                // if (snake === 'jobDescription' && this.profile.job_description) {
                //     form.append('job_description', this.profile.job_description)
                //     return
                // }

                if (snake === 'state' || snake === 'hometown') {
                    try {
                        const prefix = snake !== 'state' ? `${snake}_` : ''
                        form.append(`${prefix}state_id`, this.profile[`${prefix}state`].id)
                        if (this.profile[`${prefix}state`].is_station) {
                            form.append(`${prefix}station_id`, this.profile[`${prefix}station`].id)
                        } else {
                            form.append(`${prefix}region_id`, this.profile[`${prefix}region`].id)
                        }
                    } catch (e) {
                        return
                    }

                    return
                }
                if (snake === 'bachelor' || snake === 'master' || snake === 'doctor') {
                    form.append(`${snake}_u_id`, this.profile[`${snake}_u_id`])
                    form.append(`${snake}_u_name`, this.profile[`${snake}_u_name`] || '')
                    form.append(`${snake}_c_id`, this.profile[`${snake}_c_id`])
                    form.append(`${snake}_c_name`, this.profile[`${snake}_c_name`] || '')
                    form.append(`${snake}_m_id`, this.profile[`${snake}_m_id`])
                    form.append(`${snake}_m_name`, this.profile[`${snake}_m_name`] || '')

                    form.append(`${snake}_start`, this.profile[`${snake}_start`])
                    form.append(`${snake}_end`, this.profile[`${snake}_end`])
                    form.append(`${snake}_status`, this.profile[`${snake}_status`])
                    return
                }

                if (snake === 'high_school') {
                    form.append('high_school_name', this.profile.high_school_name || '')
                    form.append('high_school_start', this.profile.high_school_start)
                    form.append('high_school_end', this.profile.high_school_end)
                    form.append('high_school_status', this.profile.high_school_status)
                    return
                }

                if (snake === 'family_relations') {
                    form.append('brother_count', this.profile.brother_count)
                    form.append('sister_count', this.profile.sister_count)
                    form.append('order_of_children', this.profile.order_of_children)
                    return
                }

                if (snake === 'health_status') {
                    form.append('health_status', this.profile.health_status)
                    form.append('health_detail', this.profile.health_detail || '')
                    return
                }

                if (snake === 'asset') {
                    form.append('asset', this.profile[snake])
                    if (this.profile.asset_detail) form.append('asset_detail', this.profile.asset_detail)
                    return
                }
                const validProfileKey = this.profile[snake] !== undefined
                if (validProfileKey) form.append(`${snake}`, this.profile[snake])
            })

            form.append('house_owner', this.profile.house_owner !== null ? this.profile.house_owner : '')

            if (this.profile.profile_options) {
                const profileOptionIds = this.profile.profile_options.map(po => po.profile_option_id)
                form.append('profile_option_ids', JSON.stringify(profileOptionIds))
            }

            // ⚠️ 회사(company) payload는 종종 저장/전환 타이밍에 일부 필드가 비는 케이스가 있어
            // 전송 직전에 최소 필드를 방어적으로 보정한다.
            const jsonCompany = Array.isArray(this.profile.company) ? this.profile.company.map(c => ({ ...c })) : []

            // 기본값 보정
            jsonCompany.forEach(company => {
                if (company.employment_type === undefined || company.employment_type === null) {
                    company.employment_type = 1
                }
            })

            // job_category_id 누락 방어 (stage 10/11에서 간헐적으로 발생 가능)
            if (
                jsonCompany[0] &&
                (jsonCompany[0].job_category_id === undefined || jsonCompany[0].job_category_id === null)
            ) {
                // 1) 화면에서 선택된 job_category가 있으면 그 값을 우선 사용
                if (this.job_category && this.job_category.id) {
                    jsonCompany[0].job_category_id = this.job_category.id
                    if (!jsonCompany[0].job_category_name && this.job_category.name) {
                        jsonCompany[0].job_category_name = this.job_category.name
                    }
                } else if (jsonCompany[0].job_category_name) {
                    // 2) name만 있는 경우 constants에서 역매핑
                    const categories = this.$store.getters.jobCategories
                    const matched =
                        Array.isArray(categories) &&
                        categories.find(c => c && c.name === jsonCompany[0].job_category_name)
                    if (matched && matched.id) {
                        jsonCompany[0].job_category_id = matched.id
                    }
                }
            }

            form.append('company', JSON.stringify(jsonCompany))
            // form.append('company', JSON.stringify(this.profile.company))
            form.append('family', JSON.stringify(this.profile.family))
            form.append('privacy_setting', JSON.stringify(this.profile.privacy_setting))
            if (this.currentField.title === 'photo_upload') {
                this.me.photos
                    .filter(p => p.blob)
                    .forEach((p, idx) => form.append(`photo${idx + 1}`, p.blob, p.fileName))
                form.append('delete_photo_ids', JSON.stringify(this.deletePhotoIds))
            }

            // console.log('form start');
            // for (const pair of form.entries()) {
            //     console.log(pair[0] + ': ' + pair[1]);
            // }
            // console.log('form end');
            return form
        },
        setInitialStage() {
            // const profile = this.me.profile
            const profile = this.profile
            console.log('setInitialStage profile', profile)
            if (!profile.height) return 1
            if (!profile.region_name || !profile.state) return 2
            if (!profile.school) return 3
            // if (!profile.school.name) return 3
            // if (!profile.school.id) return 3
            const schoolId = (profile.school || {}).id || profile.school_id
            if (
                // [5, 6, 7, 8].indexOf(profile.school_id) !== -1 ||
                [5, 6, 7, 8].indexOf(schoolId) !== -1 ||
                (profile.school && profile.school.name.includes('학사'))
            ) {
                if (!profile.bachelor_m_name) return 4
            }

            if (profile.school.name.includes('석사')) {
                if (!profile.master_m_name) return 6
            }
            if (profile.school.name.includes('박사')) {
                if (!profile.doctor_m_name) return 8
            }

            if (!profile.company[0]) return 10
            if (!profile.company[0].job_category_name) return 10
            if (!profile.company[0].company_name && [1, 16, 17].indexOf(profile.company[0].job_category_id) === -1)
                return 11
            if (
                !profile.company[0].company_state_name &&
                [1, 16, 17].indexOf(profile.company[0].job_category_id) === -1
            )
                return 11
            if (!profile.company[0].job_name && [1, 16, 17].indexOf(profile.company[0].job_category_id) === -1)
                return 13
            if (profile.marry === null) return 14
            if (profile.income === null) return 15
            if (profile.asset === null) return 16
            if (profile.look_score_self === null) return 17

            if (!profile.mbti) return 18
            if (profile.smoking === null) return 19
            if (!profile.religion_name) return 20
            if (!profile.marry_plan) return 21
            if (this.me.photos.length < 3) return 22
            if (!this.profile.user_personal_stories || this.profile.user_personal_stories.length < 1) return 23
            return 23

            // if (!profile.height) return 1
            // if (!profile.station.name) return 2
            // if (!profile.religion_name) return 3
            // if (profile.smoking === null) return 4
            // if (!profile.mbti) return 5
            // if (!profile.school.name) return 6
            // if (profile.school.name.includes('학사')) {
            //     if (!profile.bachelor_m_name) return 7
            // }
            // if (profile.school.name.includes('석사')) {
            //     if (!profile.bachelor_m_name) return 7
            //     if (!profile.master_m_name) return 9
            // }
            // if (profile.school.name.includes('박사')) {
            //     if (!profile.bachelor_m_name) return 7
            //     if (!profile.master_m_name) return 9
            //     if (!profile.doctor_m_name) return 11
            // }
            // if (!profile.company[0].job_category_name) return 13
            // if (!profile.company[0].company_name) return 14
            // if (!profile.company[0].job_name) return 15
            // if (profile.company[0].show_employment_type === null) return 16
            // if (!profile.company[0].company_state_name) return 17
            // if (profile.income === null) return 18
            // if (profile.asset === null) return 19
            // if (!profile.marry_plan) return 20
            // if (!profile.marry) return 21
            // if (this.me.photos.length < 3) return 22
            // return 23
        },
    },
}
</script>

<style lang="scss" scoped>
/* 안드로이드 크롬에서 cta 가려짐 이슈 때문에 추가됨 2025.08.27 */
/* 이 화면(컨테이너)에서만 변수의 기본값을 0으로 선언 */
.apply-page-container {
    --android-top-ui: 0px;
    --android-bottom-ui: 0px;
}

/* 버튼 뒤로 컨텐츠가 숨어들지 않게 — 이 화면에서만 패딩 추가 */
/* 헤더가 fixed/sticky라면: 헤더 높이에 상단 UI를 더해 여유 확보 */
.apply-page.inner {
    /* 헤더 높이 예: 56px (프로젝트 헤더 실제 높이에 맞춰 조정) */
    padding-top: calc(56px + var(--android-top-ui));
    /* 버튼+여백(대략 112px) + 하단 UI */
    padding-bottom: calc(112px + var(--android-bottom-ui));
}

/* 헤더 자체가 fixed라면, 상단 UI만큼 내려주면 겹침 방지 */
:deep(.apply-header),
:deep(header) {
    /* 실제 헤더의 루트 클래스/태그로 교체 */
    top: var(--android-top-ui);
}

.inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .modal-profile-item-selector {
        height: 100%;
        width: 100%;
        padding: 1px 0 0 0 !important;
    }

    .btn {
        border: none;
        background-color: #00aa77;
        color: #fff;
        font-weight: 600;
        height: 38px;
        width: 90px;
    }
    .done {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 124px 0;
        text-align: center;
        width: 100%;
        background-image: url('/apply/apply-background.webp');
        background-position: center center;
        background-size: cover;

        .check-img {
            width: 60px;
            height: 60px;
            margin-bottom: 17px;

            @media screen and (max-width: 450px) {
                margin-bottom: 13px;
            }
        }

        .title {
            font-weight: 600;
            font-size: 28px;
            line-height: 42px;
            letter-spacing: -1.5px;
            margin-bottom: 20px;

            @media screen and (max-width: 450px) {
                margin-bottom: 30px;
                font-size: 21px;
                line-height: 29px;
            }

            @media screen and (max-width: 350px) {
                font-size: 16px;
                line-height: 25px;
            }
        }

        .explain {
            font-size: 24px;
            font-weight: 500;
            line-height: 36px; /* 150% */
            letter-spacing: -1.2px;

            @media screen and (max-width: 450px) {
                font-size: 17px;
                line-height: 27px;
            }

            @media screen and (max-width: 350px) {
                font-size: 15px;
                line-height: 24px;
            }
        }

        .desc {
            color: #0db880;
        }

        .kakao-btn {
            margin-top: 40px;
            padding: 54px;
            cursor: pointer;

            @media screen and (max-width: 450px) {
                margin-top: 16px;
                padding: 18px 0;
            }

            @media screen and (max-width: 350px) {
                margin-top: 15px;
                padding: 10px 0;
            }
        }

        @media screen and (max-width: 450px) {
            padding: 90px 20px;
        }
    }
    .question-wrap {
        justify-content: center;
        margin: auto;
        margin-top: 100px;
        margin-bottom: 100px;
        display: flex;
        flex-direction: column;
        width: 40vw;
        max-width: 300px;
        min-width: 200px;
        padding-top: 40px;

        .title {
            line-height: 150%;
            font-size: 25px;
            font-weight: 700;
            margin-bottom: 30px;
            width: 100%;
        }
        .description {
            line-height: 150%;
            margin-bottom: 15px;
            width: 100%;
        }
        .no-answer {
            color: red;
            margin-bottom: 15px;
        }
        .choice-wrap {
            margin-bottom: 30px;
            width: 100%;
            .choice {
                border: 1px solid rgba(92, 92, 119, 0.5);
                padding: 20px;
                border-radius: 8px;
                background-color: #fff;
                margin-bottom: 10px;
                width: 100%;
                color: #7c7c7c;
            }
            .choice.selected {
                background-color: #e8e4e7;
                color: #151360;
            }
        }
        .answer-input {
            font-size: 20px;
            width: 100%;
            height: 60px;
            padding: 15px;
            margin-bottom: 30px;
        }
        .answer-input-phone {
            font-size: 12px;
        }
        .answer-input[type='number'] {
            -moz-appearance: textfield;
            appearance: textfield;
        }
        .answer-input[type='number']::-webkit-inner-spin-button,
        .answer-input[type='number']::-webkit-outer-spin-button {
            appearance: none;
            -webkit-appearance: none;
        }
        .btn-wrap {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
        .btn.prev {
            margin-right: 10px;
        }
    }
}
</style>
